import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Player, GameState } from '../../domain/entities';
import { PlayerFace } from './PlayerFace';
import { TeamBadge } from './TeamBadge';
import './PlayerOfTheSeasonCard.css';

interface PlayerOfTheSeasonCardProps {
    player: Player;
    teamName: string;
    season: number;
    teamColor?: string;
    gameState: GameState;
}

export const PlayerOfTheSeasonCard: React.FC<PlayerOfTheSeasonCardProps> = ({ player, teamName, season, teamColor, gameState }) => {
    const getTeamByName = (name: string) => {
        if (name === 'Youth Academy') return undefined;
        for (const league of Object.values(gameState.leagues)) {
            const team = league.teams.find(t => t.name === name);
            if (team) return team;
        }
        return undefined;
    };
    return (
        <div className="pots-card">
            <div className="pots-card-header">
                <div className="pots-title"><FontAwesomeIcon icon={faStar} /> PLAYER OF THE SEASON <FontAwesomeIcon icon={faStar} /></div>
                <div className="pots-season">SEASON {season}</div>
            </div>
            <div className="pots-card-body">
                <div className="pots-player-face">
                    <PlayerFace player={player} teamColor={teamColor} />
                </div>
                <h3 className="pots-player-name">{player.name}</h3>
                <div className="pots-player-team">{getTeamByName(teamName)?.badge && <TeamBadge badge={getTeamByName(teamName)?.badge} color={getTeamByName(teamName)?.colors.primary} size="sm" />}{teamName}</div>
                <div className="pots-player-pos">{player.position}</div>
            </div>
            <div className="pots-card-stats">
                <div className="pots-stat">
                    <span className="pots-stat-value">{player.gamesPlayed}</span>
                    <span className="pots-stat-label">APPEARANCES</span>
                </div>
                <div className="pots-stat">
                    <span className="pots-stat-value">{player.goalsScored}</span>
                    <span className="pots-stat-label">GOALS</span>
                </div>
                <div className="pots-stat">
                    <span className="pots-stat-value">{player.assists}</span>
                    <span className="pots-stat-label">ASSISTS</span>
                </div>
                 <div className="pots-stat">
                    <span className="pots-stat-value">{player.potmAwards}</span>
                    <span className="pots-stat-label">POTM</span>
                </div>
            </div>
        </div>
    );
};